import {
	cloneElement,
	type FC,
	isValidElement,
	type ReactElement,
} from "react";
import {
	useAudienceContext,
	useAudienceModal,
} from "../providers/AudienceContext";

export interface AudienceModalProps {
	className?: string;
}

const AudienceModal: FC<AudienceModalProps> = ({ className = "" }) => {
	const { activeTabIndex, tabs } = useAudienceContext();
	const { visible, type, data, closeModal } = useAudienceModal();

	// Don't render if modal is not visible or no tabs registered
	if (
		!visible ||
		tabs.length === 0 ||
		activeTabIndex < 0 ||
		activeTabIndex >= tabs.length
	) {
		return null;
	}

	const activeTab = tabs[activeTabIndex];
	const modalContent = activeTab.modalContent;

	// Handle different types of modal content
	let renderedModal = null;

	if (typeof modalContent === "function") {
		// If modal content is a function, call it with props
		renderedModal = modalContent({
			visible,
			onClose: closeModal,
			data,
			type,
		});
	} else if (isValidElement(modalContent)) {
		// If modal content is a React element, clone it with props
		renderedModal = cloneElement(modalContent as ReactElement, {
			visible,
			onClose: closeModal,
			data,
			type,
		});
	} else {
		// If modal content is just a React node, render it as-is
		renderedModal = modalContent;
	}

	return <div className={`audience-modal ${className}`}>{renderedModal}</div>;
};

export default AudienceModal;
